import * as React from "react";

import { MessageCheckerActions, useMessageCheckerActions } from ".";
import { messageCheckerReducer } from "./messageCheckerReducer";
import {
    initialMessageCheckerState,
    MessageCheckerState,
} from "./messageCheckerState";

const MessageCheckerContext = React.createContext<{
    state: MessageCheckerState;
    actions: MessageCheckerActions;
}>(undefined);

export const MessageCheckerProvider = (props: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = React.useReducer(
        messageCheckerReducer,
        initialMessageCheckerState
    );
    const actions = useMessageCheckerActions(dispatch);

    const value = {
        state,
        actions,
    };

    return (
        <MessageCheckerContext.Provider value={value}>
            {props.children}
        </MessageCheckerContext.Provider>
    );
};

export const useMessageCheckerContext = () => {
    const context = React.useContext(MessageCheckerContext);
    if (!context) {
        throw new Error(
            "useMessageCheckerContext must be used within a MessageCheckerProvider"
        );
    }

    return context;
};
